import DataProvider from '@app/model/_common/DataProvider';
import ReviewsStateStatistics from '@app/model/review/state/ReviewsStateStatistics';

export default class StateStatisticsForProvider {
	provider: DataProvider;
	statistics: ReviewsStateStatistics;

	constructor(data: StateStatisticsForProvider) {
		Object.assign(this, data);
		this.statistics = new ReviewsStateStatistics(data.statistics);
	}
}
